<script setup>
import {onUnmounted} from 'vue';

document.querySelector('#app').classList.add('landing');

onUnmounted(() => document.querySelector('#app').classList.remove('landing'));
</script>

<template>
  <div class="d-flex align-center no-wrap landing__content">
    <div class="landing__title">
      <h1 class="mx-right fw-500">Реєстр музейного фонду України</h1>
    </div>
    <div class="landing__form d-flex-self mx-auto w-50">
      <div class="landing__form-content">
        <slot />
      </div>
    </div>
  </div>
  <div class="landing__footer">
    <div class="d-flex justify-between">
      <div class="fs-12">
        <p>Розроблено Strimco та адмініструється МКСК з любов'ю 💙💛</p>
        <p>© “Міністерство культури та стратегічних комунікацій України” <span>{{new Date().getFullYear()}}</span>. Всі права захищено</p>
      </div>
      <div
        class="alert fs-12 text-black d-inline-flex align-center"
        :class="$store.state.notification.type"
        v-if="$store.state.notification.text"
      >
        <i class="i-alert"/> {{ $store.state.notification.text }}
      </div>
    </div>
    <div class="landing__footer--sponsor">
      <i class="landing__footer--sponsor__logo"/>
      <span class="landing__footer--sponsor__info">
        Співфінансовано за кошти Фонду допомоги, зазначеного в ст. 14 п. 1 Закону від 12 березня 2022
        року про допомогу громадянам України у зв’язку зі збройним конфліктом на території цієї держави
        (Законодавчий вісник за 2022 рік, поз. 583), розпорядником яких є Міністр культури та національної
        спадщини – допомога громадянам України, які постраждали від збройного конфлікту на території України.
      </span>
      <span class="landing__footer--sponsor__info">
        Dofinansowano ze środków z Funduszu Pomocy, o którym mowa w art. 14 ust. 1 ustawy z dnia 12 marca 2022 r.
        o pomocy obywatelom Ukrainy w związku z konfliktem zbrojnym na terytorium tego państwa
        (Dz. U. z 2022 r. poz. 583), których dysponentem jest
        Minister Kultury i Dziedzictwa Narodowego – pomoc obywatelom Ukrainy dotkniętym konfliktem zbrojnym
        na terytorium Ukrainy.
      </span>
    </div>
  </div>
</template>
